<template>
  <div>
    <div class="contents">
      <div class="top"><input type="button" class="back" @click="back" /> 내 차량 위치</div>
      <div class="content">
        <div ref="map" align="center" class="map h_middle">
        </div>
      </div>
      <ul class="toolbar" toolbar="toolbar" viewer="viewer">
        <li @click="zoomOut(img)">-</li>
        <li class="zoom">
          <span>{{Math.round(current * 100)}}%</span>
        </li>
        <li @click="zoomIn(img)">+</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'detailMap',
  data() {
    return {
      current: 0.2,
      img: '',
    };
  },
  props: ['api'],
  created() {
    const item = !this._.isEmpty(this.$store.getters.chosenItem) ? this.$store.getters.chosenItem : JSON.parse(sessionStorage.getItem('chosenItem'));
    this.$http({
      method: 'post',
      url: this.api.mapUrl,
      responseType: 'blob',
      data: {
        siteId: item.site.siteId,
        mapName: item.location.position.mapImg,
        carNumber: item.carNumber,
        x: item.location.position.xy[0],
        y: item.location.position.xy[1],
        resolution: item.location.position.resolution,
        size: item.location.position.size,
        block: item.location.blockName
      }
    })
    .then((response) => {
      const img = document.createElement('img');
      img.src = URL.createObjectURL(new Blob([response.data], {type: 'image/png'}));
      img.alt = '주차장 지도';
      img.onload = () => {
        img.setAttribute('style', this.getStyle(this.getHeightWithoutPX(img)) + "width: " + this.getWidth(img) + ';');
        this.img = img;
        this.$refs.map.appendChild(this.img);
        this.$refs.map.style.width = this.width + 'px';
        this.$refs.map.style.height = this.height + 'px';
      };

    });
  },
  methods: {
    back() {
      this.$router.push('/list');
    },
    zoomIn(map) {
      this.current += 0.1;
      map.setAttribute('style', this.getStyle(this.getHeightWithoutPX(map)) + "width: " + this.getWidth(map) + ';');
    },
    zoomOut(map) {
      if (this.current < 0.2) return false;

      this.current -= 0.1;
      map.setAttribute('style', this.getStyle(this.getHeightWithoutPX(map)) + "width: " + this.getWidth(map) + ';');
    },
    initScreenSize() {
      this.width = window.screen.width;
      this.height = (window.screen.height - 120);
    },
    getWidth(map) {
      return (map.naturalWidth * this.current) + "px";
    },
    getHeightWithoutPX(map) {
      return map.naturalHeight * this.current;
    },
    getStyle(imgHeight) {
      return this.height > imgHeight ? "margin: auto; position: absolute; top: 0; left: 0; bottom: 0; right: 0;" : "";
    }
  }
};
</script>

<style scoped>

</style>